import AddVehicleDriverInfoModal from './add-vehicle-driver-info-modal.vue'
export default AddVehicleDriverInfoModal
